export default {
    path: '/leads',
    preload: true,
    middlewares: [{
        "rms_ui/validatePermissionsMiddleware": [
            ["marketing.lead_list"],
            "/"
        ]
    }],
}
